module.exports = __webpack_public_path__ + "static/exterior-2-6eca948e0f54809c6548a0695d1e72c3.jpg";